import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  toast: {
    paddingTop: 1.5,
    paddingBottom: 1.5
  },
  toastContent: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 1,
    width: '100%',
    height: '100%'
  },
  toastIcon: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyLarge
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%',
    gap: 0.5
  },
  body: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  closeButton: {
    height: '22px',
    width: '22px'
  },
  closeIcon: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault
  }
});
